module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PROLOGUE")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Key West, Florida"), _c('br'), _vm._v(" Friday, July 13, 2001"), _c('br'), _vm._v(" 11:00 p.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("P")])]), _vm._v("astor Rachel Howard peered out the bedroom’s rear window, struggling to see past the sheets of rain. Thunder shook the one-hundred-and-twenty-year-old parsonage, followed immediately by a flash of lightning so bright it stung her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shrank back from the ground-floor window, retreating to the absolute darkness of the room once more. She didn’t want them, the ones who watched, to suspect what she was up to. They were coming for her. She didn’t know who they were, only that there were many of them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was more powerful than she had imagined. Craftier. More vile.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She had underestimated his reach. An error. A fatal one, she feared.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel squeezed her eyes shut, words from the Twenty-third Psalm running through her head, comforting her. Drowning out the litany of other voices, ones no one but she could hear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Yea, though I walk through the valley of the shadow of death, I will fear no evil; for Thou art with me.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She planned to escape tonight and head to the mainland. Once safe, she would decide her best course of action. If she made it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A sense of calm came over her; a momentary peace. In death his glory awaited. No matter the outcome of this night, the darkness would not have her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel opened her eyes and inched toward the window once more, clutching the envelope in her hands more tightly. Her friend would come despite the storm. He wouldn’t let her down.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She prayed he wouldn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And she prayed she hadn’t endangered his life by asking for his help.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She imagined their laughter, their tauntings. She amused them, she knew. Her Lord amused them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Thunder boomed again, reverberating through her. In the flash of lightning she saw her friend dart across the garden, a shapeless figure in a rain-slicked poncho.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Moments later he appeared at the window. Gratitude and affection flooded her senses; tears stung her eyes. She lifted the window and handed him the envelope.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Take it. Make sure my sister gets it.” He nodded but didn’t speak. “Now go, quickly.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He hesitated a moment, then turned and disappeared into the storm.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("Rachel wasted no time. She grabbed her raincoat and ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("umbrella, purse and car keys, and slipped out into the night. Flower petals littered the path before her, torn from the canopy of branches above by the wind and rain, the bruised poinciana blossoms forming a kind of bloody carpet.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her Toyota was parked around the back of the parsonage. She started for it, working to keep her pace leisurely enough not to call attention to herself. She didn’t want them to guess what she was up to.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The rain beat down on her umbrella, sluicing over the sides, splattering at her feet. Her lips moved as she silently spoke the words of the Apostles’ Creed:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I believe in God the Father Almighty, maker of heaven and earth.")])]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I believe in Jesus Christ, his only son, our Lord.")])]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I believe in—")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She heard a sound from behind her. She stopped and turned, heart thundering in her chest. “Stephen?” she whispered, voice trembling. “Is that you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The rain stopped. The wind died. She felt the breath of death stir against her face, its stench as foul as the grave.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a cry, Rachel broke into a run. The parking area in sight, she stumbled on a loose paver. Her car keys slipped from her fingers, clattering against the walkway. She scrambled to retrieve them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She closed her fingers around the keys. The bushes rustled; she heard a soft laugh. She twisted her head, looking back. Lightning flashed; she caught the glint of metal as it arced through the darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No!” She leaped to her feet and ran, tripping once but righting herself.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She reached her car, curled her fingers around the door handle and yanked. The door popped open. She heard them following her. Without looking back, she scrambled behind the wheel and slammed the door shut. She hit the lock and attempted to insert the key into the ignition, her hands shaking so badly it took her three tries.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Finally the engine sputtered, then turned over. Sobbing with relief, she threw the car into Reverse and floored the accelerator. The vehicle shot backward, fishtailing on the wet pavement.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel shifted to Drive and gunned the engine. As the car leaped forward, she whispered a prayer of thanks. She had done it! She was going to make it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rachel dared a glance back, searching for her pursuers, unable to see past the wall of rain. She returned her gaze to the road. Her headlights fell across something blocking her way. A figure, she realized, standing in the middle of the road.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A scream ripping past her lips, Rachel simultaneously yanked the wheel to the right and jammed on the brakes. The car lurched sideways, sliding on the wet pavement, going into a three-sixty spin. Rachel fought to regain control of the vehicle, praying for a miracle. Knowing it was too late.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The vehicle jettisoned off the pavement. A tree rushed up to meet the car. Rachel threw up her arms to shield her face as the impact sent her flying forward.")])])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page12"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-467ab810","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459280410_fm02.vue
// module id = 78
// module chunks = 0